// extracted by mini-css-extract-plugin
export default {"infoDiv":"ModalForTransactionsExel_infoDiv__zrdgu","spanDiv":"ModalForTransactionsExel_spanDiv__Mk4hw","inputs":"ModalForTransactionsExel_inputs__MCt6F"};